import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPortalOutlinedArrowDownIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.5 5.83337L8.33333 10.5L14.1667 5.83337", stroke: "#333333", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgPortalOutlinedArrowDownIcon);
const Memo = memo(ForwardRef);
export default Memo;
